import { render, staticRenderFns } from "./ClientTimelineItem.vue?vue&type=template&id=2b513a23&scoped=true&"
import script from "./ClientTimelineItem.vue?vue&type=script&lang=js&"
export * from "./ClientTimelineItem.vue?vue&type=script&lang=js&"
import style0 from "./ClientTimelineItem.vue?vue&type=style&index=0&id=2b513a23&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b513a23",
  null
  
)

export default component.exports